



































import { defineComponent, PropType, watch } from '@vue/composition-api';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import SearchGroupUsers from '@front-app/components/inputs/SearchGroupUsers.vue';
import SelectedUserButton from '@front-app/components/buttons/SelectedUserButton.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import { UserStore } from '@front-app/store/singletons/User';
import { STATUS } from '@front-app/constants/state';
import { SearchOption } from '@front-app/components/search/useSearch';
import { UserSearchItem } from '@front-app/services/UserApi/UserModel';

export default defineComponent({
	components: {
		FormSection,
		FormLabel,
		SearchGroupUsers,
		SelectedUserButton,
		HelpTooltipBlock,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		selectedSpeakerIds: {
			type: Array as PropType<string[]>,
			required: true,
		},
		preferredSpeakerIds: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
	},
	setup(props, ctx) {
		const userStore = UserStore.getInstance();
		watch(() => props.selectedSpeakerIds, (curr) => {
			userStore.fetchMany(curr);
		}, { immediate: true });
		watch(() => props.preferredSpeakerIds, (curr) => {
			userStore.fetchMany(curr);
		}, { immediate: true });
		const selectSpeaker = (user: SearchOption<UserSearchItem>) => {
			userStore.setPartial({
				...user.original,
				status: STATUS.SUCCESS,
			});
			ctx.emit('select', user);
		};
		return {
			selectSpeaker,
		};
	},
});
